// "Copy link to block" addresses a block as "<page>#block-<blockId>".
const HASH_PREFIX = "#block-";

export function blockIdFromHash(hash: string): string | null {
  if (!hash.startsWith(HASH_PREFIX)) return null;
  const id = hash.slice(HASH_PREFIX.length);
  return id ? decodeURIComponent(id) : null;
}
